import { createFileRoute, redirect } from '@tanstack/react-router'
import { CycleRaters } from '@/features/hr-performance/cycle-raters'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one review cycle: its rater editor while a draft, its
 * progress once launched. The API enforces `performance_cycle.view` and
 * `.edit`; this guard only keeps a user without the grant off the screen.
 */
export const Route = createFileRoute('/_authenticated/hr/performance/cycles/$cycleId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'performance_cycle.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: CycleRatersRoute,
})

function CycleRatersRoute() {
  const { cycleId } = Route.useParams()
  return <CycleRaters cycleId={cycleId} />
}
